export default __webpack_public_path__ + "static/media/india.0530155b.svg";